import HouseMain from './HouseMain'

export { HouseMain }
